import MainPageView from "./MainPageView";

export default MainPageView;
